import {
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import { ReactComponent as NoGoalProtectionImage } from "../../assets/img/nogoalprotection.svg";
import { colors } from "../../style/color/colors";
import { AuthContext } from "../../Hooks/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useEditGoalInDashboard } from "../../api/apiEndpoints/EditGoalsInDashboard";
import { String } from "../../constants/Strings";

const NoGoalsComponents = ({ isEditClick }) => {
  const [openPrompt, setOpenPrompt] = useState(false);
  const { authTokens } = useContext(AuthContext);
  const { EditGoals } = useEditGoalInDashboard();

  const { userId } = authTokens;
  const navigate = useNavigate();
  const handleEditClick = () => {
    setOpenPrompt(true);
  };

  const handleClosePrompt = () => {
    setOpenPrompt(false);
  };

  const handleConfirmEdit = async () => {
    try {
      const data = {
        userId: userId,
        areGoalsEdited: true,
      };
      const response = await EditGoals(data);
      if (response.httpCode === 200) {
        navigate(String.navigations.goal, {
          state: { someCondition: true, userId: userId },
        });
      }
    } catch (error) {}

    setOpenPrompt(false);
  };

  return (
    <>
      <Card
        sx={{
          borderRadius: 7,
          mt: "10%",
          background: "linear-gradient(to bottom,rgb(211, 236, 249), #FFFFFF)",
          display: "flex",
        }}
      >
        <Stack
          sx={{
            p: 2,
            width: "50%",
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          <Typography sx={{ color: colors.ColorpalettePrimaryMidnight }}>
            <span style={{ fontWeight: 600 }}>Add goals</span> to get a more
            precise financial overview.
          </Typography>

          <Button
            sx={{
              mt: "50px",
              backgroundColor: !isEditClick
                ? colors.ColorButtonPrimarysurface
                : "#bab7b6",
              color: colors.PrimaryWhite,
              borderRadius: "40px",
            }}
            onClick={handleEditClick}
            disabled={isEditClick}
          >
            {String.Dashboard.mainDashboard.EditGoal}
          </Button>
        </Stack>
        <NoGoalProtectionImage style={{ width: 200, height: 200 }} />
      </Card>
      <Dialog
        open={openPrompt}
        onClose={handleClosePrompt}
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <DialogTitle>
          {String.Dashboard.mainDashboard.GoalEditingAreyoySure}
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ fontSize: 16, fontWeight: "bold" }}>
            {String.Dashboard.mainDashboard.goalEditWarning}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 1,
            p: 1,
            mb: 2,
          }}
        >
          <Button
            onClick={handleClosePrompt}
            color={colors.PrimaryWoodSmoke}
            variant="outlined"
            sx={{
              backgroundColor: colors.PrimaryWhite,
              color: colors.NeutralDark700,
              textTransform: "capitalize",
            }}
          >
            {String.Cancel}
          </Button>
          <Button
            onClick={handleConfirmEdit}
            color={colors.PrimaryWoodSmoke}
            sx={{
              backgroundColor: colors.ColorButtonPrimarysurface,
              color: colors.PrimaryWhite,
              textTransform: "capitalize",
            }}
          >
            {String.Yes}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NoGoalsComponents;
